export default "__VITE_ASSET__C0Lca0Qw__"